import type { timecode } from "../types.d";

export const toSec = (timecode: timecode): number => {
  if (typeof timecode === "number") return timecode;
  if (/^[0-9]+(\.([0-9]+)?)?$/.test(timecode)) {
    return parseFloat(timecode);
  }
  const match = timecode.match(
    new RegExp("([0-9]{1,2}):([0-9]{1,2})(.[0-9]+)?"),
  );
  if (!match) return 0;
  const [min, sec, frac] = [match[1], match[2], match[3]];
  return 60 * parseInt(min) + parseInt(sec) + parseFloat(frac || "0");
};
